/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { displayModal, sendMessage } from '@insticator/insticator-ui'; // iui-state
import { invalidateSelectedContent, invalidateActiveAddOn } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import PreviewCTA from 'material/ctas/preview/preview';



/* ========== ~~~~~~~~~~ CTA : PREVIEW : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => {
	const contentStatus = embedsState.embedManagementState.contentStatus;
	return {
        selectedContent: !!contentStatus.contents ? contentStatus.contents[contentStatus.selectedContent] : null,
		editingAddOn: embedsState.embedManagementState.selectedEmbedStatus.editingAddOn,
		userDataCollection: embedsState.embedManagementState.contentStatus.addons.userDataCollection,
	}
};

// map actions
const mapDispatchToProps = dispatch => ({
	displayModal: (isVisible, contentToDisplay, showCloseButton) => {
		dispatch(displayModal(isVisible, contentToDisplay, showCloseButton))
	},
    invalidateSelectedContent: () => dispatch(invalidateSelectedContent()),
	invalidateActiveAddOn: (addOn) => dispatch(invalidateActiveAddOn(addOn)),
	sendMessage: message => dispatch(sendMessage(message))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
	mapStateToProps,
    mapDispatchToProps
)(PreviewCTA);
